import { z } from 'zod';

/**
 * 消息角色枚举（叙事通道）。
 */
export const GameMessageRole = z.enum(['user', 'assistant', 'narrator']);
